import { render, staticRenderFns } from "./update-vacation.vue?vue&type=template&id=2b7986d0"
import script from "./update-vacation.vue?vue&type=script&lang=js"
export * from "./update-vacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports